module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerWrapper"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-menu', {
    staticClass: "el-menu-header",
    attrs: {
      "theme": "dark",
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    staticClass: "home-link",
    attrs: {
      "index": "1"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/marca_logo.min.svg")
    }
  })])], 1), _vm._v(" "), (_vm.auth.user !== null) ? _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_c('span', [_vm._v("Projects")])])], 1) : _vm._e(), _vm._v(" "), (_vm.auth.user !== null) ? _c('el-submenu', {
    attrs: {
      "index": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.auth.user.email))]), _vm._v(" "), (_vm.userMeta.isAdmin == true) ? _c('el-menu-item', {
    attrs: {
      "index": "5-1"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/users')
      }
    }
  }, [_vm._v("Manage Users")]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5-2"
    },
    on: {
      "click": function($event) {
        _vm.logOut()
      }
    }
  }, [_vm._v("Logout")])], 2) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e417fa48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 348
// module chunks = 2